/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateDeploymentRequestBody,
  CreateDeploymentRequestBody$Outbound,
  CreateDeploymentRequestBody$outboundSchema,
} from "../components/createdeploymentrequestbody.js";

export type CreateDeploymentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateDeploymentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateDeploymentSecurity = {
  option1?: CreateDeploymentSecurityOption1 | undefined;
  option2?: CreateDeploymentSecurityOption2 | undefined;
};

export type CreateDeploymentRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * A unique identifier that will mitigate against duplicate deployments.
   */
  idempotencyKey: string;
  createDeploymentRequestBody: CreateDeploymentRequestBody;
};

/** @internal */
export type CreateDeploymentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateDeploymentSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateDeploymentSecurityOption1$Outbound,
  CreateDeploymentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createDeploymentSecurityOption1ToJSON(
  createDeploymentSecurityOption1: CreateDeploymentSecurityOption1,
): string {
  return JSON.stringify(
    CreateDeploymentSecurityOption1$outboundSchema.parse(
      createDeploymentSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateDeploymentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateDeploymentSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateDeploymentSecurityOption2$Outbound,
  CreateDeploymentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createDeploymentSecurityOption2ToJSON(
  createDeploymentSecurityOption2: CreateDeploymentSecurityOption2,
): string {
  return JSON.stringify(
    CreateDeploymentSecurityOption2$outboundSchema.parse(
      createDeploymentSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateDeploymentSecurity$Outbound = {
  Option1?: CreateDeploymentSecurityOption1$Outbound | undefined;
  Option2?: CreateDeploymentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateDeploymentSecurity$outboundSchema: z.ZodMiniType<
  CreateDeploymentSecurity$Outbound,
  CreateDeploymentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateDeploymentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateDeploymentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createDeploymentSecurityToJSON(
  createDeploymentSecurity: CreateDeploymentSecurity,
): string {
  return JSON.stringify(
    CreateDeploymentSecurity$outboundSchema.parse(createDeploymentSecurity),
  );
}

/** @internal */
export type CreateDeploymentRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Idempotency-Key": string;
  CreateDeploymentRequestBody: CreateDeploymentRequestBody$Outbound;
};

/** @internal */
export const CreateDeploymentRequest$outboundSchema: z.ZodMiniType<
  CreateDeploymentRequest$Outbound,
  CreateDeploymentRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    idempotencyKey: z.string(),
    createDeploymentRequestBody: CreateDeploymentRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      idempotencyKey: "Idempotency-Key",
      createDeploymentRequestBody: "CreateDeploymentRequestBody",
    });
  }),
);

export function createDeploymentRequestToJSON(
  createDeploymentRequest: CreateDeploymentRequest,
): string {
  return JSON.stringify(
    CreateDeploymentRequest$outboundSchema.parse(createDeploymentRequest),
  );
}
